import React from 'react'
import PageConfig from '@/component/layout/PageConfig.tsx'
import { equalString } from '@/util/strings.ts'
import NotificationLayout from '@/pages/notification/layout/NotificationLayout.tsx'
import { useSearchParams } from 'react-router-dom'
import NotificationEmergencyContainer from '@/pages/notification/NotificationEmergencyContainer.tsx'
import NotificationBioContainer from '@/pages/notification/NotificationBioContainer.tsx'
import NotificationFalldetectionContainer from '@/pages/notification/NotificationFalldetectionContainer.tsx'

interface IProps {
}

const NotificationPage: React.FunctionComponent<IProps> = ({}) => {
    const [searchParams] = useSearchParams()
    const activeTab = searchParams.get('tab') || 'sos'

    return (
        <>
            <PageConfig showSideNav={true} showTopNav={true}>
                <NotificationLayout>
                    {equalString(activeTab, 'sos') && <NotificationEmergencyContainer />}
                    {equalString(activeTab, 'bio') && <NotificationBioContainer />}
                    {equalString(activeTab, 'fall') && <NotificationFalldetectionContainer />}
                </NotificationLayout>
            </PageConfig>
        </>
    )
}

export default NotificationPage
